/**
 * aiApplicationAlert模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const aiApplicationAlert = {
  // 案例分页
  pageAiApplicationAlert(params) {
    return $http.post(`${global.API_URL}/sme/aiApplicationAlert/page`,params);
  },
  // 是否忽略
  changeStatus(params) {
    return $http.post(`${global.API_URL}/sme/aiApplicationAlert/changeStatus`,params);
  }
}

export default aiApplicationAlert;



// WEBPACK FOOTER //
// ./src/api/aiApplicationAlert.js